import React, { ReactNode } from "react";
import DisplayMediaObject from "../MediaObjectSection/DisplayMediaObject";
import { MediaObject } from "../../types/MediaObject";
import { ExternalReferenceFile } from "../../types/ExternalReferenceFile";

type DisplayMediaObjectsProps = {
  mediaObjects: Array<MediaObject> | ExternalReferenceFile["mediaObjects"];
  mediaObjectToDisplay: MediaObject | null;
  setMediaObjectToDisplay: Function;
  titleElement?: ReactNode;
};

export default function DisplayMediaObjects({
  mediaObjects,
  mediaObjectToDisplay,
  setMediaObjectToDisplay,
  titleElement,
}: DisplayMediaObjectsProps) {
  if (!mediaObjectToDisplay) {
    return null;
  }

  let currentIndex = mediaObjects.findIndex((mediaObject) => mediaObject.id === mediaObjectToDisplay.id);

  if (currentIndex === -1) {
    return null;
  }

  const hasNextImage = typeof mediaObjects[currentIndex + 1] !== "undefined";
  const hasPreviousImage = typeof mediaObjects[currentIndex - 1] !== "undefined";

  const switchImage = (direction: string) => {
    if (direction === "next" && hasNextImage) {
      setMediaObjectToDisplay(mediaObjects[currentIndex + 1]);
    }
    if (direction === "previous" && hasPreviousImage) {
      setMediaObjectToDisplay(mediaObjects[currentIndex - 1]);
    }
  };

  return (
    <DisplayMediaObject
      closeDialog={() => setMediaObjectToDisplay(null)}
      mediaObject={mediaObjectToDisplay}
      hasNextImage={hasNextImage}
      hasPreviousImage={hasPreviousImage}
      switchImage={switchImage}
      titleElement={titleElement}
    />
  );
}
